<template>
  <div class="panel" :class="statusClass">
    <div class="panel-header" style="background-color: initial">
      <div class="panel-title statused">{{statusLabel}}</div>
    </div>
    <div class="panel-body">
      <p v-if="item.task">
        <small class="view-label">Задача</small>
        <span class="text-bolder">{{item.task}}</span>
      </p>
      <p v-if="item.short">
        <small class="view-label">Сделано</small>
        <span class="text-bolder">{{item.short}}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item'],
  computed: {
    statusLabel() {
      if (this.item.date) {
        const d = new Date(this.item.date);
        return (this.item.completed ? 'Выполнена ' : 'Запланирована ') + d.toLocaleDateString('ru');
      }
      return 'Отложена';
    },
    statusClass() {
      const status = this.item.date ? (this.item.completed ? 3 : 1) : 2;
      return this.$utils.statusClass(status, this.item.msDate);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/work-item.vue